import { styled } from '@mui/material/styles';

import Colors from 'common/ui/Colors';

export const TopBar = styled('div', { shouldForwardProp: p => p !== 'warning' })<{
  warning?: boolean;
}>(({ theme: { spacing }, warning }) => ({
  alignItems: 'center',
  padding: spacing(3),
  background: warning ? Colors.WARNING_LIGHT_BG : Colors.INFO_LIGHT,
  borderBottom: `1px ${Colors.GREY_30} solid`,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  width: '100%',
  gap: spacing(5),
}));
